export const icheck ={
    data(){
        return{
            itemSelect:{ val:[], isValid:true }
        }
    },
    methods: {
        icheck(e)
        {
            //console.log(e);
            let ckvalue = e.target.children[0].defaultValue
            if( ckvalue ==="all")
            {
                let elements = document.querySelectorAll("input[type='checkbox']");
                let i=0
                if(e.target.classList.contains('red'))
                {
                    for ( i=0; i<elements.length; i++) {
                        elements[i].parentNode.classList.remove('red')
                    }
                    this.itemSelect.val =[];
                }else{

                    for ( i=0; i<elements.length; i++) {
                        elements[i].parentNode.classList.add('red')
                        if(elements[i].value !=="all")
                        {
                            this.itemSelect.val.push(elements[i].value);
                        }
                    }
                }
            }else{
                //있으면 빼고 없으면 넣고
                //체크 상태를 확인. class로 판단
                //if(this.itemSelect.val.some(item => item === ckvalue))
                if(e.target.classList.contains('red'))
                {
                    let itemIndex = this.itemSelect.val.indexOf(ckvalue)
                    this.itemSelect.val.splice(itemIndex, 1)
                }else{
                    this.itemSelect.val.push(ckvalue);
                    this.itemSelect.isValid = true;
                }
                e.target.classList.toggle('red');
            }
            console.log(this.itemSelect.val);
        }
    },
}
